export function PortalFooter() {
  return (
    <footer className="portal-footer">
      <div className="footer-left">
        <a href="mailto:support@aicores.ai" className="footer-link">
          Need help?
        </a>
        <a href="mailto:support@aicores.ai" className="footer-link">
          Contact
        </a>
      </div>
      <div className="footer-legal">
        AICORES<sup>®</sup> {new Date().getFullYear()} · A product of Arkkeys Systems Limited
      </div>
    </footer>
  );
}
